import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IPaymentBenefitSectionProps {
  $bgColor?: string;
  $textColor?: string;
}

export const PaymentBenefitSection = styled.div<IPaymentBenefitSectionProps>`
  background: #fff;
  padding: 32px 0;

  ${({ $bgColor, $textColor }) =>
    ($bgColor || $textColor) &&
    css`
      background: ${$bgColor};
    `}

  &.bg-type-black {
    background: #000;

    .main-title {
      color: #fff;
    }
  }

  .event-notice {
    padding: 20px 20px 0;
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('32 0')};

    > .text {
      padding: ${mixin.pxToVw('0 20')};
    }

    .event-notice {
      padding: ${mixin.pxToVw('20 20 0')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    padding: 65px 57px;

    .event-notice {
      padding: 30px 0 0;
    }
  }
`;
